import {Component, OnInit} from '@angular/core';
import {MessageChannelService, messageLevel} from '@bndes/bndes-ux4/bndes-angular-utils';
import {ActivatedRoute, Router} from '@angular/router';
import {ModalidadeGarantia} from 'src/app/model/modalidade_garantia.model';
import {ModalidadeScrModel} from '../../../model/modalidade-scr.model';
import {ModalidadeScrService} from '../modalidade-scr.service';

@Component({
  selector: 'app-habilitacao-scr',
  templateUrl: './habilitacao-scr.component.html',
  styleUrls: ['./habilitacao-scr.component.scss'],
  standalone: false
})
export class HabilitacaoScrComponent implements OnInit {

  public listarNaoHabilitados: ModalidadeScrModel[];
  public scrDisponiveis: ModalidadeScrModel[] = [];
  public scrAdicionados: ModalidadeScrModel[] = [];
  public modalidade: ModalidadeGarantia;

  constructor(protected route: ActivatedRoute,
              public service: ModalidadeScrService,
              private messageService: MessageChannelService,
              private router: Router) {
  }

  ngOnInit() {
    this.service.listarNaoHabilitados().subscribe(res => {
      this.listarNaoHabilitados = res;
    });
  }

  atribuirPrograma(scrModalidade: ModalidadeScrModel, i) {
    const indexProgramaAAdicionar = this.listarNaoHabilitados.findIndex(p => p.id === scrModalidade.id);
    if (indexProgramaAAdicionar > -1) {
      this.listarNaoHabilitados[indexProgramaAAdicionar];
    }
    this.scrAdicionados[i] = scrModalidade;
  }

  removerPrograma(i) {
    const programaASerRemovido = this.scrDisponiveis[i];
    const indexProgramaARemover = this.listarNaoHabilitados.findIndex(programa => programa.id === programaASerRemovido.id);
    if (indexProgramaARemover > -1) {
      this.listarNaoHabilitados[indexProgramaARemover];
    }
    this.scrDisponiveis.splice(i, 1);
    this.scrAdicionados.splice(i, 1);
  }

  adicionarPrograma() {
    this.scrDisponiveis.push(new ModalidadeScrModel());
    this.scrAdicionados.push(new ModalidadeScrModel());
  }

  salvar() {
    const programasIdsAAdicionar = this.scrAdicionados.map(p => p.codigoScrModalidade);
    const setProgramasIdsAAdicionar = new Set(programasIdsAAdicionar);
    if (programasIdsAAdicionar.length > setProgramasIdsAAdicionar.size) {
      this.messageService.addMessage({
        title: 'error',
        type: 'CRUD_OPERATION',
        level: messageLevel.ERROR,
        message: 'Há programa duplicado'
      });
      return;
    }

    this.service.habilitar(this.scrAdicionados).subscribe(() => {
      this.messageService.addMessage({
        title: 'Sucesso',
        type: 'CRUD_OPERATION',
        level: messageLevel.SUCCESS,
        message: 'Novo programa habilitado com sucesso'
      });
      this.router.navigate(['/modalidade-scr']);
    });
  }
}
